<div class="login-page">
  <div class="login-box">
    <div class="login-logo">
      <img
        src="../../assets/img/ImgAlanser.png"
        width="300"
        alt="Alanser"
        class="brand-image ielevation-3"
      />
    </div>
    <div class="card">
      <div class="card-body login-card-body">
        <p class="login-box-msg">Identifíquese para iniciar sesión</p>
        <form name="form" #f="ngForm" novalidate>
          <div class="form-group input-group mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="Usuario"
              autocomplete="off"
              name="vUsuar"
              [(ngModel)]="vUsuar"
              (focus)="reset()"
              required
            />
            <div class="input-group-append">
              <div class="input-group-text">
                <fa-icon [icon]="icoUsu"></fa-icon>
              </div>
            </div>
          </div>
          <div class="form-group input-group mb-3">
            <input
              type="password"
              class="form-control"
              placeholder="Contraseña"
              autocomplete="off"
              name="vClave"
              [(ngModel)]="vClave"
              (focus)="reset()"
              required
            />
            <div class="input-group-append">
              <div class="input-group-text">
                <fa-icon [icon]="icoClv"></fa-icon>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <button class="btn btn-cave btn-block" (click)="login()">
                <fa-icon [icon]="icoEnt"></fa-icon> Iniciar sesión
              </button>
            </div>
          </div>
          <div
            *ngIf="resul"
            class="spinner-border text-primary"
            role="status"
          ></div>
        </form>
        <div class="ponError">
          <span *ngIf="xErro">{{ xErro }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
